import React from 'react'
import { useTranslation } from 'next-i18next'

const ConfirmationPopup = ({ content, children, onClick, onCancel, cancelContent, fullscreen }) => {
  const { t } = useTranslation('common')
  return (
    <>
      <div className={`fixed w-full h-full bg-black opacity-50 top-0 left-0 z-[${fullscreen ? 99999 : 999}]`}></div>
      <div className="top-0 left-0 right-0 bottom-0 m-auto fixed w-[400px] h-[200px] z-[9999] text-center p-5  flex justify-around flex-col modal-background font-bold">
        <p className="text-black">{content}</p>
        {children && children}
        <div className="flex justify-center gap-4">
          <button
            className="min-w-[70px] py-3 px-6 text-black text-base bg-neutral-400 rounded-sm"
            onClick={onCancel ? onCancel : onClick}
          >
            {cancelContent || t('common.cancel').toUpperCase()}
          </button>
          <button
            className="min-w-[100px] py-3 px-6 rounded-sm bg-black text-white text-base flex items-center"
            onClick={onClick}
          >
            {t('common.confirm').toUpperCase()}
          </button>
        </div>
      </div>
    </>
  )
}

export default ConfirmationPopup
